import {getUserRoleService} from '@/services/adminPortalService';

export async function getUserRoleUseCase(signal) {
  return getUserRoleService(signal);
}
